<template>
  <settings-form :breadcrumbs="breadcrumbs">
    <template #actions>
      <v-btn
        class="mr-2"
        color="success"
        @click="add"
      >
        <v-icon>mdi-plus</v-icon>
        {{ $t('button.add_new_user') }}
      </v-btn>
    </template>
    <template #content>
      <v-data-table
        class="clickable-table"
        :headers="computedHeaders"
        :items="users"
        disable-pagination
        hide-default-footer
        mobile-breakpoint="0"
        @click:row="edit"
      >
        <template #item.name="{ item }">
          <span :class="[{'font-weight-bold': isActive(item)}]">{{ item.name }}</span>
        </template>
        <template #item.username="{ item }">
          <span :class="[{'font-weight-bold': isActive(item)}]">{{ item.username }}</span>
        </template>
        <template #item.email="{ item }">
          <span :class="[{'font-weight-bold': isActive(item)}]">{{ item.email }}</span>
        </template>
      </v-data-table>
    </template>
  </settings-form>
</template>

<script lang="ts">
import Vue from 'vue';
import User from '@/model/User';
import SettingsForm from '@/components/layouts/SettingsForm.vue';
import SettingsBreadcrumbs from '@/mixins/settings-breadcrumbs';

export default Vue.extend({
  name: 'Users',
  components: { SettingsForm },
  mixins: [SettingsBreadcrumbs],
  data() {
    return {
      headers: [
        {
          text: this.$i18n.t('label.first_name'),
          value: 'name',
          align: 'start',
          sortable: false,
        },
        {
          text: this.$i18n.t('label.username'),
          value: 'username',
          align: 'start',
          sortable: false,
          mdAndUp: true,
        },
        {
          text: this.$i18n.t('label.email'),
          value: 'email',
          align: 'start',
          sortable: false,
        },
      ],
      breadcrumbs: [],
    };
  },
  computed: {
    computedHeaders(): any[] {
      return this.headers.filter((e) => (!e.mdAndUp || (e.mdAndUp && this.$vuetify.breakpoint.mdAndUp)));
    },
    users(): User[] {
      const { users } = this.$tstore.state.settings;
      const activeUser = this.$tstore.getters.activeUser as User | undefined;
      if (activeUser) return [activeUser, ...users.filter((u) => u.id !== activeUser.id)];
      return users;
    },
  },

  methods: {
    edit(o: User, prop: any) {
      this.$router.push(`/settings/users/${o.id}`);
    },
    add() {
      this.$router.push('/settings/users/new');
    },
    isActive(o: User) {
      const activeUser = this.$tstore.getters.activeUser as User | undefined;
      return o.id === activeUser?.id;
    },
  },
});
</script>
